// 优惠券
const CardCollecting = () => import('../pages/cardCollecting/index.vue');

export default [
  {
    path: '/cardCollecting',
    component: CardCollecting,
    meta: {
      title: '集卡活动',
    },
  },
];
